.registreringContent {
  margin-top: var(--dds-spacing-medium-40);
}
